<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="
     Signature électronique
    "
    class="!max-w-[640px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[12px]">
        <span>
          La signature électronique n'est pas activée pour
          {{
            props.contrat?.typeContrat === 'Contrat'
              ? 'ce contrat formateur'
              : 'cet avenant'
          }}.
          <template v-if="props.contrat?.organismeEmail">
            Veuillez signer le document manuellement, puis l'envoyer à votre
            organisme de formation pour validation (<a
              v-bind:href="`mailto:${props.contrat?.organismeEmail}`"
              class="whitespace-nowrap text-blue-600 underline">
              {{ props.contrat.organismeEmail }} </a
            >).
          </template>
          <template v-else>
            Veuillez contacter votre organisme de formation.
          </template>
        </span>
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        v-if="props.on_close"
        variant="primary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { FormateurContrat } from '@/types/formateur/formateur-contrat';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      contrat?: FormateurContrat;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
